import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Row, Col, Alert, Button, Spinner } from 'react-bootstrap';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import CustomerDetailContent from '../components/CustomerDetailContent';
import { useGetCustomersId } from '../api/generated/arrayscapeGamingDashboardAPI';

const CustomerDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: customer, isLoading, error, refetch } = useGetCustomersId(id || '', {
    query: { enabled: !!id },
  });

  if (isLoading) {
    return (
      <DashboardLayout title="Customer Details" subtitle="Loading...">
        <Row className="justify-content-center py-5">
          <Col xs="auto">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        </Row>
      </DashboardLayout>
    );
  }

  if (error || !customer) {
    return (
      <DashboardLayout title="Customer Details" subtitle="Error loading customer">
        <Row className="mb-4">
          <Col>
            <Alert variant="danger">
              <i className="bi bi-exclamation-triangle me-2"></i>
              {(error as any)?.message || 'Customer not found'}
            </Alert>
            <Button variant="primary" onClick={() => navigate('/customers')}>
              <i className="bi bi-arrow-left me-2"></i>
              Back to Customers
            </Button>
          </Col>
        </Row>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout title="Customer Details" subtitle={customer.name} scrollable>
      <CustomerDetailContent customer={customer} onRefresh={refetch} />
    </DashboardLayout>
  );
};

export default CustomerDetail;
